import { TableColumn } from "../table/TableColumn";

const MapRelayColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "name",
        isDefault: true
    },
    {
        heading: "Floors",
        accessor: "floors",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "floors",
        isDefault: true
    },
    {
        heading: "Relays",
        accessor: "relays",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "relays",
        isDefault: true
    },
    {
        heading: "Inputs",
        accessor: "inputs",
        isNumeric: false,
        id: 4,
        active: true,
        translationKey: "inputs",
        isDefault: true
    },

];

export default MapRelayColumns;